import {applyMessageStyle} from "app/widgets/Message/messageUtil";

const Message = kendo.ui.Widget.extend({
    options: {
        name: "Message",
        type: "error"
    },

    init: function() {
        kendo.ui.Widget.fn.init.apply(this, arguments);
        this.wrapper = this.element;
        applyMessageStyle(this.element, this.options.type);
    }
});
kendo.ui.plugin(Message);
export default Message;
